<template>
    <div class="layout-container">
        <div class="main-container">
            <div class="sidebar">
                <div class="menu-sidebar-top">
                     <img src="/logo.png" alt="PlePower">
                     <div class="brand-copy">
                        <h4>PlePower</h4>
                        <span>Utility Dashboard</span>
                     </div>
                </div>
                <div class="menu-sidebar" v-if="user_role == 1">
                    <router-link class="sub-menu" to="/home"><i class="fa fa-home"></i>&nbsp;Home </router-link>
                      <div class="sub-menu" @click="utility_menu('/electricity/purchase')" ><i class="fas fa-lightbulb"></i> &nbsp; Electricity Payment </div>
                    <div class="sub-menu" @click="utility_menu('/airtime/purchase')"><i class="fa fa-mobile"></i>&nbsp; Airtime Topup </div>
                    <div class="sub-menu" @click="utility_menu('/data/purchase')"><i class="fa fa-wifi"></i>&nbsp; Buy Data </div>
                    <div class="sub-menu" @click="utility_menu('/cable-tv/purchase')"><i class="fa fa-tv"></i>&nbsp; Cable TV </div>
                    <router-link class="sub-menu" to="/subscriptions"><i class="fa fa-database"></i>&nbsp;Subscriptions </router-link>
                    <router-link class="sub-menu" to="/wallet-transactions"><i class="fa fa-wallet"></i>&nbsp;Wallet Transactions </router-link>
                    <router-link class="sub-menu" to="/all-wallets"><i class="fa fa-wallet"></i>&nbsp;All Wallets </router-link>
                    <router-link class="sub-menu" to="/all-users"><i class="fa fa-users"></i>&nbsp;All Users  </router-link>
                    <router-link class="sub-menu" to="/all-disputes"><i class="fa fa-paw" aria-hidden="true"></i>&nbsp;All Disputes  </router-link>
                    <router-link class="sub-menu" to="/profile"><i class="fa fa-user"></i>&nbsp;Profile  </router-link>
                  
                </div>
                <div class="menu-sidebar" v-else>
                    <router-link class="sub-menu" to="/home"><i class="fa fa-home"></i>&nbsp;Home </router-link>
                    <div class="sub-menu" @click="utility_menu('/electricity/purchase')" ><i class="fas fa-lightbulb"></i> &nbsp; Electricity Payment </div>
                    <div class="sub-menu" @click="utility_menu('/airtime/purchase')"><i class="fa fa-mobile"></i>&nbsp; Airtime Topup </div>
                    <div class="sub-menu" @click="utility_menu('/data/purchase')"><i class="fa fa-wifi"></i>&nbsp; Buy Data </div>
                    <div class="sub-menu" @click="utility_menu('/cable-tv/purchase')"><i class="fa fa-tv"></i>&nbsp; Cable TV </div>
                    <router-link  class="sub-menu" to="/my-subscriptions"><i class="fa fa-credit-card" aria-hidden="true"></i>&nbsp;My Subscriptions  </router-link>
                    <router-link class="sub-menu" to="/disputes"><i class="fa fa-paw" aria-hidden="true"></i>&nbsp;Dispute Resolutions  </router-link>
                    <router-link class="sub-menu" to="/profile"><i class="fa fa-user"></i>&nbsp;Profile  </router-link>
                </div>
            </div>

            <div class="mobile-backdrop" v-if="isMenuOpen" @click="close_menu()"></div>
    
            <div class="content">
                <div class="top-header">
                    <div class="header-left">
                        <button class="menu-toggle" @click="show_menu()" aria-label="Open menu">
                            <i class="fa fa-bars"></i>
                        </button>
                        <div class="page-intro">
                            <p class="page-label">Dashboard</p>
                            <h3>{{ pageTitle || 'Welcome back' }}</h3>
                        </div>
                    </div>
                    <div class="mobile-drawer" :class="{ open: isMenuOpen }">
                        <div class="mobile-drawer-header">
                            <div class="menu-sidebar-top">
                                <img src="/logo.png" alt="PlePower">
                                <div class="brand-copy">
                                    <h4>PlePower</h4>
                                    <span>Utility Dashboard</span>
                                </div>
                            </div>
                            <button class="close-menu" @click="close_menu()" aria-label="Close menu">X</button>
                        </div>
                        <!-- <img src="../assets/bar.svg" alt="" > -->
                        <div class="submenu-bar" v-if="user_role == 1">
                            <div class="sub-menu1"  @click="close_menu('/home')"><i class="fa fa-home"></i>&nbsp;Home </div>
                            
                            <div class="sub-menu1" @click="utility_menu('/electricity/purchase')" ><i class="fas fa-lightbulb"></i> &nbsp; Electricity Payment </div>
                             <div class="sub-menu1" @click="utility_menu('/airtime/purchase')"><i class="fa fa-mobile"></i>&nbsp; Airtime Topup </div>
                            <div class="sub-menu1" @click="utility_menu('/data/purchase')"><i class="fa fa-wifi"></i>&nbsp; Buy Data </div>
                            <div class="sub-menu1" @click="utility_menu('/cable-tv/purchase')"><i class="fa fa-tv"></i>&nbsp; Cable TV </div>
                            <div class="sub-menu1"  @click="close_menu('/subscriptions')"><i class="fa fa-database"></i>&nbsp;Subscriptions </div>
                             <div class="sub-menu1"  @click="close_menu('/wallet-transactions')"><i class="fa fa-wallet"></i>&nbsp;Wallet Transactions </div>
                            <div class="sub-menu1"  @click="close_menu('/all-wallets')"><i class="fa fa-wallet"></i>&nbsp;All Wallets </div>
                            <div class="sub-menu1"  @click="close_menu('/all-users')"><i class="fa fa-users"></i>&nbsp;All Users  </div>
                            <div class="sub-menu1"  @click="close_menu('/all-disputes')"><i class="fa fa-paw" aria-hidden="true"></i>&nbsp;All Disputes </div>
                            <div class="sub-menu1"  @click="close_menu('/profile')"><i class="fa fa-user"></i>&nbsp;Profile  </div>
                        </div>
                        <div class="submenu-bar" v-else>
                            <div class="sub-menu1"  @click="close_menu('/home')"><i class="fa fa-home"></i>&nbsp;Home </div>
                            <div class="sub-menu1" @click="utility_menu('/electricity/purchase')" ><i class="fas fa-lightbulb"></i> &nbsp; Electricity Payment </div>
                            <div class="sub-menu1" @click="utility_menu('/airtime/purchase')"><i class="fa fa-mobile"></i>&nbsp; Airtime Topup </div>
                            <div class="sub-menu1" @click="utility_menu('/data/purchase')"><i class="fa fa-wifi"></i>&nbsp; Buy Data </div>
                            <div class="sub-menu1" @click="utility_menu('/cable-tv/purchase')"><i class="fa fa-tv"></i>&nbsp; Cable TV </div>
                            <div class="sub-menu1"  @click="close_menu('/my-subscriptions')"><i class="fa fa-database"></i>&nbsp;My Subscriptions </div>
                            <div class="sub-menu1"  @click="close_menu('/disputes')"><i class="fa fa-paw"></i>&nbsp;Dispute Resolutions </div>
                            <div class="sub-menu1"  @click="close_menu('/profile')"><i class="fa fa-user"></i>&nbsp;Profile  </div>
                
                        </div>
                    </div>
                    <div class="message-notifications">
                        <div class="dropdown1">
                             <p class="fullname"><strong>{{ firstname }}</strong> </p>
                             <span class="email-text">{{ email }}</span>
                        </div>
                        <div class="dropdown1 profile-dropdown" ref="profileDropdown">
                            <button class="notifications user-circle profile-trigger" @click.stop="toggleProfileMenu">
                                {{ name_initial || 'U' }}
                            </button>
                            <div class="dropdown-menu1" v-if="isProfileMenuOpen">
                                <p @click="vendorLogout()" style="cursor: pointer;">Logout</p>
                            </div>
                        </div>
                    </div>
                </div>
                <router-view/>
            </div>
        </div>
    
        <!-- <div class="footer">
            Privacy Policy | Disclaimer
            Follow us on: &nbsp; <i class="fa fa-linkedin-square"></i> &nbsp; <i class="fa fa-facebook-square" aria-hidden="true"></i> &nbsp; <i class="fa fa-youtube-square"></i>
            <br>
            &copy;{{ new Date().getFullYear() }} {{ appTitle }} All rights reserved.
        </div> -->
    </div>
    
</template>
<script>
import inactivityMixin from '../mixins/inactivityMixin';
import { clearStoredSession } from '../utils/auth';
export default {

    name: "Dashboard",
    mixins: [inactivityMixin],
    components: {

    },

    data(){
        return {
            appTitle: 'PlePower',
            //appTitle: process.env.VUE_APP_COMPANY,
            firstname: '',
            lastname: '',
            email: '',
            name_initial: '',
            user_role: '',
            pageTitle: '',
            isProfileMenuOpen: false,
            isMenuOpen: false, // Control menu visibility
        };
    },

    created() {
    this.$root.$on('title', (title) => {
      this.pageTitle = title;
        });
    },
    beforeDestroy() {
        this.$root.$off('title');
        document.removeEventListener('click', this.handleOutsideClick);
    },
      
    beforeMount(){
        document.title = this.appTitle
    },
    mounted() {
        this.user_role = localStorage.getItem("user_role");
        this.firstname = localStorage.getItem("firstname");
        this.lastname = localStorage.getItem("lastname");
        this.email = localStorage.getItem("email");

        if (this.firstname) {
        this.name_initial = this.firstname.charAt(0);
        } else {
        this.name_initial = ''; // Handle the case where firstname is empty
        }

        document.addEventListener('click', this.handleOutsideClick);
    },
   
    computed: {
        
    },
    methods:{
        show_menu(){
            this.isMenuOpen = true; // Show the submenu-bar
        },
        toggleProfileMenu(){
            this.isProfileMenuOpen = !this.isProfileMenuOpen;
        },
        handleOutsideClick(event){
            const dropdown = this.$refs.profileDropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.isProfileMenuOpen = false;
            }
        },
        utility_menu(router){
            this.isMenuOpen = false;
            this.isProfileMenuOpen = false;
            this.$router.push(router)
        },
        close_menu(router){
            this.isMenuOpen = false; // Show the submenu-bar
            this.isProfileMenuOpen = false;
            if (router) {
                this.$router.push(router)
            }
        },
        vendorLogout(){
            this.isProfileMenuOpen = false;
            clearStoredSession();
            localStorage.removeItem("bank_name");
            localStorage.removeItem("account_name");
            localStorage.removeItem("account_number");
            window.location.href = '/';
        }
    }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');

.close-menu{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 12px;
    background: #edf2ee;
    color: #24562B;
    font-size: 28px;
    line-height: 1;
}
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
    background: linear-gradient(180deg, #f5f8f6 0%, #edf2ee 100%);
}

.search-bar{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.top-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 20;
    padding: 20px 32px;
    border-bottom: 1px solid #e2e8e4;
    background: rgba(255, 255, 255, 0.94);
    backdrop-filter: blur(12px);
}
.header-left{
    display: flex;
    align-items: center;
    gap: 1rem;
}
.page-intro{
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    h3{
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #18362d;
    }
}
.page-label{
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #6c8a7c;
}
.message-notifications {
    display: flex;
    align-items: center;
    gap: 14px;
}

.dropdown1 {
    position: relative;
}
.profile-dropdown{
    display: flex;
    align-items: center;
}
.bell-circle{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: solid 1px #ccc;
    background: #fff;
    padding: 10px;
}
.user-circle{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px solid #d8e3dc;
    background: linear-gradient(135deg, #24562B 0%, #2f6c37 100%);
    color: #fff;
    font-weight: 700;
    padding: 10px;
    width: 46px;
    height: 46px;
}

.notifications {
    font-size: 20px;
    cursor: pointer;
    position: relative;
}
.profile-trigger{
    border: 0;
    outline: none;
}

.dropdown-menu1 {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background-color: white;
    border: 1px solid #e1e8e3;
    border-radius: 14px;
    padding: 10px 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    min-width: 150px;
}

.dropdown-menu1 p {
    margin: 0;
    padding: 5px 0;
    font-size: 14px;
    color: #333;
}

.dropdown-menu1 a {
    display: block;
    text-decoration: none;
    color: #007bff;
    font-size: 14px;
    margin-top: 5px;
}

.inputs-field{
    font-size: 14px;
    font-family: Poppins;
    height: 45px;
    width: 400px;
    border-radius: 0px;
    position: relative;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #cccccc2b;
    border: solid 0px;
}
.search-button{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem;
    background: #cccccc2b;
    color: #ccc;
    border-radius: 0px;
    font-family: Poppins;
    font-size: 18px;
    text-transform: capitalize;
    height: 45px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.logo-title {
    padding: 30px 30px 20px;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 800;
    color: #fff;
    flex: 1;
    border-bottom: solid 1px #ccc;
}

.menu-bar {
    flex: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.menu-bar .submenu-bar {
    display: none;
}

.menu-bar .fa-bars:hover + .submenu-bar,
.menu-bar .submenu-bar:hover {
    display: block;
    position: absolute;
    background: #24562B;
}

.user-info {
    flex: 1;
    text-align: right;
}

.dropdown .dropbtn {
    background-color: #24562B;
    color: #000;
    padding: 12px;
    font-size: 12px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    width: 100%;

    span{
        color: white;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px;
        width: 30px;
        height: 30px;
        background: #312F33;
        border-radius: 47px;
        margin: 10px;
    }
}

.main-container {
    display: flex;
    flex: 1;
}
.menu-sidebar-top {
    display: flex;
    flex-direction: row;
    justify-content:left;
    align-items: center;
    gap: 0.85rem;
    padding: 34px 24px 8px;

    h4{
        font-family: Poppins;
        font-size: 15px;
        font-weight: 700;
        color: #24562B;
        margin: 0;
    }

    img{
        width: 44px;
        height: 44px;
        object-fit: contain;
    }
}
.brand-copy{
    display: flex;
    flex-direction: column;

    span{
        font-size: 11px;
        color: #6c8a7c;
        font-family: Poppins;
    }
}
.menu-sidebar {
    padding: 20px 14px 24px;
}
.sub-menu{
    cursor: pointer;
}

.sidebar {
    background: #fff;
    box-shadow: 0 18px 40px rgba(0,0,0,0.08);
    position: fixed;
    top: 18px;
    left: 18px;
    bottom: 18px;
    height: auto;
    width: 240px;
    overflow-y: auto; /* Allows scrolling if the content is longer than the viewport */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    z-index: 10; /* Keeps it on top of other elements */
    border: 1px solid #e4ebe6;
    border-radius: 24px;
}

.sidebar::-webkit-scrollbar {
    display: none;
}

.sidebar .sub-menu {
    display: block;
    color: #27453b;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 6px;
    padding: 12px 14px;
    border-radius: 14px;
   
}

.sidebar .sub-menu:hover {
    background: #24562B;
    color: #fff;
}
.sidebar .router-link-exact-active{
    background: linear-gradient(135deg, #24562B 0%, #2f6c37 100%);
    color: #fff;
}

.content {
    flex: 1;
    width: 100%;
    background: transparent;
    margin-left: 274px;
    min-width: 0;
}
.mobile-backdrop{
    display: none;
}
.mobile-drawer{
    display: none;
}
.menu-toggle{
    display: none;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: 1px solid #d8e3dc;
    border-radius: 14px;
    background: #fff;
    color: #24562B;
    flex-shrink: 0;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}
.fullname{
    margin: 0;
    font-family: Poppins;
    font-size: 14px;
    color: #18362d;
}
.email-text{
    display: block;
    font-size: 11px;
    color: #789085;
    font-family: Poppins;
}

.footer {
    text-align: center;
    padding: 10px;
    background: #fff;
    box-shadow: 0 -1px 2px rgba(0,0,0,0.1);
}

 .menu-bar{
    display:none;
 }

 .logo-title{
    display:block;
 }

/* Style The Dropdown Button */
.dropbtn {
   // background-color: #4CAF50;
    color: white;
    //padding: 16px;
    font-size: 16px;
    border: none;
    cursor: pointer;
  }
  
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }
  
  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #000;
    color: #f1f1f1 !important;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
  
  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 3px 16px;
    text-decoration: none;
    display: block;
    border-bottom: solid 1px #ccc;
  }
  
  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {background-color: #474646}
  
  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {
    display: block;
  }
  
  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {
    //background-color: #3e8e41;
  }
#green {
    height: 100%;
    background: #fff;
    text-align: center;
    color: black;
    font-family: Poppins;
}
.dropdown-menu {
    margin-left: 250px;
    background: #fff;

    .dropdown-item:hover{
        color: #ff4d63;
        font-weight: 650;
    }
}
.navbar-bgcolor{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #24562Bc7;
    color: #fff;
    font-family: Poppins;
    box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.3);

    a{
        color: #fff !important;
        text-decoration: none;
        font-size: 15px !important;
        font-weight: normal !important;

        img{
            width: 60px;
        }
    }
    a:hover{
        color: #fff;
    }
}
.navbar-brand{
    font-weight: 700;
    font-size: 14px !important;
}
.nav-link:hover{
    background: #f1b3ac;
    border-radius: 4px;
}

@media screen and (max-width: 991px) { 

    .top-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 16px;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.038);
        width: 100%;
        background: #fff;
    }
    .header-left{
        min-width: 0;
    }
    .page-intro{
        min-width: 0;

        h3{
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 180px;
        }
    }
    .search-bar{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .user-circle{
        border-radius: 50%;
        width: 45px;
    }
    .menu-sidebar-top {
        display: flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;
        padding: 10px 10px 0;
    
        .fullname{
            font-size: 24px;
            font-weight: 700;
            line-height: 30px;
            font-family: Poppins;
            font-weight: 500;
            text-transform: capitalize;
            color: #fff;
        }
        .email{
            font-family: Montserrat;
            font-size: 12px;
            font-weight: 400;
            line-height: 1px;
            color: #7F7F7F;
    
        }
        img{
            width: 20% !important;
        }
    }
    .inputs-field{
        width: 100%;
    }
    .message-notifications{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        align-items: center;
        gap: 8px;
    }
    .notifications{
       margin: 5px;
    }
    .envelope{
        padding-right: 0px;
    }
    .envelope:hover{
        cursor: pointer;
    }
    .bell:hover{
        cursor: pointer;
    }

    .sidebar{
        display: none;
    }
    .mobile-backdrop{
        display: block;
        position: fixed;
        inset: 0;
        background: rgba(6, 19, 13, 0.42);
        //z-index: 39;
    }
    .content {
        flex: 1;
        width: 100%;
        margin-left: 0px; /* This should match the sidebar width */
        padding: 0px; /* Optional: add some padding */
    }
    .logo-title{
        display: none;
    }
    .mobile-drawer{
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        height: 100dvh;
        width: 84%;
        max-width: 320px;
        padding: 18px 16px 24px;
        background: #ffffff;
        box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
        transform: translateX(-100%);
        transition: transform 0.25s ease;
        z-index: 40;
        overflow-y: auto;
    }
    .mobile-drawer.open{
        transform: translateX(0);
    }
    .mobile-drawer-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 1rem;
    }
    .submenu-bar{
        display:block;
        justify-content: left;
        flex: 1;
        overflow-y: auto; /* Allows scrolling if the content is longer than the viewport */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        z-index: 1000; /* Keeps it on top of other elements */
        padding-top: 0.5rem;
        img{
            cursor: pointer;
        }
     }
     .submenu-bar::-webkit-scrollbar {
        display: none;
    }

     .menu-toggle{
        display:flex;
     }
     .sub-menu{
        cursor: pointer;
     }
     .sub-menu1{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        text-transform: capitalize;
        cursor: pointer;
        width: 100%;
        color: #27453b;
        text-decoration: none;
        padding: 12px 14px;
        margin-bottom: 6px;
        border-radius: 14px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
     }
     .sub-menu1:hover{
        background: #24562B;
        color: #fff;
     }
     
    .menu{
        display: none;       
    }
    .dropdown-menu {
        margin-left: 0;
    }

    .dropdown {
        font-size: 12px;
      }
    .fullname{
        font-size: 12px;
    }
    .email-text{
        display: none;
    }
    
    .avater{
        font-size: 12px;
        display: flex;
    }
    .navbar-bgcolor{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #24562Bc7;
        color: #fff;
        font-family: Poppins;
       box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.3);
    
        a{
            color: #fff !important;
            text-decoration: none;
            font-size: 13px !important;
            font-weight: normal !important;
    
            img{
                width: 50px;
            }
        }
        a:hover{
            color: #fff;
        }
    }
}

</style>
